/* Copyright (c) 2022 Xperi. All Rights Reserved. */

export const SET_GHOST_MODE = 'SET_GHOST_MODE';
export const SET_GUIDE_HIGHLIGHT_TO_INITIAL_POSITION = 'SET_GUIDE_HIGHLIGHT_TO_INITIAL_POSITION';
export const SET_HORIZONTAL_PAGE_COUNT = 'SET_HORIZONTAL_PAGE_COUNT';
export const SET_HORIZONTAL_POSITION = 'SET_HORIZONTAL_POSITION';
export const SET_HORIZONTAL_SESSION = 'SET_HORIZONTAL_SESSION';
export const SET_VERTICAL_AND_HORIZONTAL_POSITION = 'SET_VERTICAL_AND_HORIZONTAL_POSITION';
export const SET_VERTICAL_PAGE_COUNT = 'SET_VERTICAL_PAGE_COUNT';
export const SET_VERTICAL_POSITION = 'SET_VERTICAL_POSITION';
export const UPDATE_HIGHLIGHT_POSITION = 'UPDATE_HIGHLIGHT_POSITION';
